/**
 * #82 — thrown by `assertSiteWritable` (and therefore by every site-mutating
 * store entry point) when a write is attempted against a site that is locked
 * by another user and the caller is not an admin. Callers (UI affordances,
 * upload queue, sim-save) catch it to surface a "site is locked by {name}"
 * toast instead of a generic failure. The `siteId` + `lockedByName` carry
 * enough context to render that message without a second lookup.
 *
 * Lives in lib (not the store) so the headless app store used by server and
 * worker runtimes throws the same class; `store/index.ts` re-exports it.
 */
export class SiteLockedError extends Error {
  readonly siteId: string;
  readonly lockedByUid?: string;
  readonly lockedByName?: string;
  constructor(args: { siteId: string; lockedByUid?: string; lockedByName?: string }) {
    super(
      `Site ${args.siteId} is locked for editing${args.lockedByName ? ` by ${args.lockedByName}` : ''
      }. Request edit access or ask an admin to unlock it.`,
    );
    this.name = 'SiteLockedError';
    this.siteId = args.siteId;
    this.lockedByUid = args.lockedByUid;
    this.lockedByName = args.lockedByName;
  }
}
